import { ReactElement } from "react";

import { setData } from "rivals/shared/utils/qa";
import styles from "./Input.module.scss";
import { OwnProps } from "./types";

function InputWrapper({
  className,
  data = "",
  feedback = "",
  hint = "",
  htmlFor = "",
  infoPrompt = "",
  label = "",
  children
}: OwnProps): ReactElement {
  return (
    <div className={className}>
      <label
        className={styles.label}
        htmlFor={htmlFor}
        {...setData(data, "label")}
      >
        {label}
        {children}

        {hint && (
          <div className={styles.hint} {...setData(data, "hint")}>
            {hint}
          </div>
        )}
        {feedback && (
          <div
            className={styles.feedback}
            dangerouslySetInnerHTML={{ __html: feedback }}
            {...setData(data, "feedback")}
          />
        )}
        {infoPrompt && (
          <div className={styles.infoPrompt} {...setData(data, "info-prompt")}>
            {infoPrompt}
          </div>
        )}
      </label>
    </div>
  );
}

export default InputWrapper;
